import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home/home.vue'
// import Index from '../components/index.vue'
import Contact from '../components/contactus.vue'
// 立体教材
import Teachingmat from '../components/teachingmaterial/teachingmat.vue'
import Matdetails from '../components/teachingmaterial/matdetails.vue'
import Chaptertest from '../components/teachingmaterial/chaptertest.vue'
import Repositories from '../components/resource-bank/repositories.vue'
import Resdetails from '../components/resource-bank/resdetails.vue'
import Reslist from '../components/resource-bank/reslist.vue'
import Rescoursedet from '../components/resource-bank/rescoursedet.vue'
import Coursedetails from '../components/resource-bank/coursedetails.vue'
import Sourselist from '../components/resource-bank/sourselist.vue'
import Soursedet from '../components/resource-bank/soursedet.vue'
// 个人中心
import Center from '../components/center/center.vue'
import Mycourse from '../components/center/mycourse.vue'
import Self from '../components/center/self.vue'
import Study from '../components/center/study.vue'
import Collection from '../components/center/collection.vue'
import Publish from '../components/center/publish.vue'


// 书目下载
import Catalog from '../components/catalog/catalog.vue'
// 教师认证
import Authentication from '../components/authentication/authentication.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/Teachingmat',
    children: [
        // { path: '/index', component: Index },
        { path: '/contact', component: Contact },
        { path: '/teachingmat', component: Teachingmat },
        { path: '/teachingmat/Matdetails', component: Matdetails },
        { path: '/teachingmat/Matdetails/chaptertest', component: Chaptertest },
        { path: '/repositories', component: Repositories },
        { path: '/repositories/resdetails', component: Resdetails },
        { path: '/repositories/reslist', component: Reslist },
        { path: '/repositories/rescoursedet', component: Rescoursedet },
        { path: '/repositories/coursedetails', component: Coursedetails },
        { path: '/repositories/sourselist', component: Sourselist },
        { path: '/repositories/soursedet', component: Soursedet },
        { path: '/catalog', component: Catalog },
        { path: '/authentication', component: Authentication },
        {
            path: '/center', component: Center,
            redirect: '/center/self',
            children: [
                { path: '/center/mycourse', component: Mycourse },
                { path: '/center/self', component: Self },
                { path: '/center/study', component: Study },
                { path: '/center/collection', component: Collection },
                { path: '/center/publish', component: Publish },
            ]
        },
    ]
},
{
    path: '/teamaterial',
    name: 'teamaterial',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/teamaterial.vue')
}
]
const ensureHashMode = () => {
    const currentUrl = window.location.href;
    const { pathname, search } = window.location; // 提取当前路径和查询参数
  
    // 1. 判断 URL 中是否已有 #（避免重复添加）
    if (currentUrl.indexOf('#') === -1) {
      // 2. 核心修复：拼接「当前路由路径 + 查询参数」到 Hash 后
      // pathname：当前路径（如 /home、/detail/123）
      // search：查询参数（如 ?name=test，可选）
      const hashPath = `#${pathname}${search}`;
      // 3. 拼接完整 URL（原 URL 去掉路径和参数，只保留协议、域名、端口）
      // 例：原 URL 是 http://xxx.com/home?name=test → 提取 http://xxx.com + #/home?name=test
      const baseUrl = currentUrl.split(pathname)[0];
      const hashUrl = `${baseUrl}${hashPath}`;
  
      console.log('无 Hash，重定向到：', hashUrl);
      window.location.replace(hashUrl);
    }
  };

ensureHashMode();
const router = new VueRouter({
    routes
})
router.afterEach(() => {
    ensureHashMode();
  });
export default router